module.exports = __webpack_public_path__ + "static/blog-go-kubernetes-1005e2e70e9a044977e9c2790404e895.jpeg";